import type { Uuid } from '@sibe/utilities/common';

import type { HsLayer } from './layer.class';

export abstract class HsObjectQueue {
  public order: number = 0;

  constructor(public readonly uuid: Uuid, public layer: HsLayer) {}
}
